import { c as _c } from "react/compiler-runtime";
export const ZeroPercentIcon = t0 => {
  const $ = _c(13);
  const {
    selected
  } = t0;
  const fillColor = selected ? "#EFFCF8" : "#008254";
  const t1 = selected ? "#008254" : "#EFFCF8";
  let t2;
  if ($[0] !== t1) {
    t2 = <rect x="0.928711" width="40" height="40" rx="20" fill={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] !== fillColor) {
    t3 = <path d="M20.1499 17.6001C20.1499 17.1733 20.0662 16.7503 19.9028 16.356C19.7395 15.9617 19.4995 15.604 19.1978 15.3022C18.896 15.0005 18.5383 14.7605 18.144 14.5972C17.7497 14.4338 17.3267 14.3501 16.8999 14.3501C16.4731 14.3501 16.0501 14.4338 15.6558 14.5972C15.2615 14.7605 14.9038 15.0005 14.6021 15.3022C14.3003 15.604 14.0603 15.9617 13.897 16.356C13.7336 16.7503 13.6499 17.1733 13.6499 17.6001V22.3999C13.6499 22.8267 13.7336 23.2497 13.897 23.644C14.0603 24.0383 14.3003 24.396 14.6021 24.6978C14.9038 24.9995 15.2616 25.2395 15.6558 25.4028C16.0501 25.5662 16.4731 25.6499 16.8999 25.6499C17.3267 25.6499 17.7497 25.5662 18.144 25.4028C18.5382 25.2395 18.896 24.9995 19.1978 24.6978C19.4995 24.396 19.7395 24.0383 19.9028 23.644C20.0662 23.2497 20.1499 22.8267 20.1499 22.3999V17.6001ZM21.6499 22.3999C21.6499 23.0237 21.5273 23.642 21.2886 24.2183C21.0499 24.7944 20.6993 25.3183 20.2583 25.7593C19.8173 26.2002 19.2934 26.5499 18.7173 26.7886C18.1411 27.0272 17.5236 27.1499 16.8999 27.1499C16.2762 27.1499 15.6587 27.0272 15.0825 26.7886C14.5064 26.5499 13.9825 26.2002 13.5415 25.7593C13.1005 25.3183 12.7499 24.7944 12.5112 24.2183C12.2725 23.642 12.1499 23.0237 12.1499 22.3999V17.6001C12.1499 16.9765 12.2726 16.3589 12.5112 15.7827C12.7499 15.2064 13.1004 14.6828 13.5415 14.2417C13.9826 13.8006 14.5062 13.4501 15.0825 13.2114C15.6587 12.9728 16.2763 12.8501 16.8999 12.8501C17.5235 12.8501 18.1411 12.9728 18.7173 13.2114C19.2936 13.4501 19.8172 13.8006 20.2583 14.2417C20.6994 14.6828 21.0499 15.2064 21.2886 15.7827C21.5272 16.3589 21.6499 16.9765 21.6499 17.6001V22.3999Z" fill={fillColor} />;
    t4 = <path d="M29.2538 14.5025C29.425 14.1633 29.8287 14.0023 30.1913 14.1412C30.5539 14.2801 30.7467 14.6698 30.6473 15.0367L30.6229 15.11L26.6698 25.4273C26.5215 25.814 26.0878 26.0072 25.701 25.859C25.3144 25.7107 25.1212 25.2769 25.2694 24.8902L29.2225 14.5728L29.2538 14.5025Z" fill={fillColor} />;
    t5 = <path d="M25.6834 19.1897C26.1878 18.9647 26.4144 18.3735 26.1894 17.8691C25.9645 17.3647 25.3732 17.1381 24.8688 17.3631C24.3644 17.588 24.1379 18.1792 24.3628 18.6837C24.5878 19.1881 25.179 19.4146 25.6834 19.1897Z" fill={fillColor} />;
    t6 = <path d="M31.104 22.7565C31.6084 22.5315 31.835 21.9403 31.61 21.4359C31.3851 20.9315 30.7939 20.7049 30.2895 20.9299C29.7851 21.1548 29.5585 21.746 29.7834 22.2505C30.0084 22.7549 30.5996 22.9814 31.104 22.7565Z" fill={fillColor} />;
    $[2] = fillColor;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">{t2}{t3}{t4}{t5}{t6}</svg>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};